// extracted by mini-css-extract-plugin
module.exports =  {"SecretDashboard":"SecretDashboard__yOGWq","supplierInfo":"supplierInfo__0-g3D"};